export const FORM_CONTROL_RADIUS_CLASS = 'rounded-lg';

export const FORM_CONTROL_SHELL_CLASSES = `${FORM_CONTROL_RADIUS_CLASS} border border-primary-100 bg-basic-100 transition-[box-shadow,border-color] duration-150 ease-out`;

export const FORM_CONTROL_SHELL_HOVER_CLASSES = 'hover:border-primary-200';

export const FORM_CONTROL_SHELL_FOCUS_CLASSES = 'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary-500 focus-visible:border-primary-500';

export const FORM_CONTROL_HEIGHT_SM = 'box-border h-8 min-h-8 px-2.5 text-xs leading-normal';

export const FORM_CONTROL_HEIGHT_MD = 'box-border h-9 min-h-9 px-3 text-sm leading-normal';

export const FORM_CONTROL_HEIGHT_LG = 'box-border h-10 min-h-10 px-4 text-base leading-normal';
